import {useEffect,useState} from 'react'
//import {UserEditModalHeader} from './UserEditModalHeader'
//import {UserEditModalFormWrapper} from './UserEditModalFormWrapper'
import { ViewModalHeader } from './ViewModalHeader'
import axios from 'axios'
import Swal from 'sweetalert2'
import { useAuth } from '../../../auth'
import { useAppSelector } from '../../../../../redux/hooks'
import SelectTenant from '../../accounts/datatransfer/components/SelectTenant_subs'
import { getFeaturesDisponibles,getFeaturesDisponiblesGlobal } from '../request/request'
import { getSubscriptionsList } from '../request/request'
const API_URL = process.env.REACT_APP_API_URL


type x=
{
  id: string
  name:string
  description:string
}

type objetocontinente ={
  name: string,
  code: string,
  type: string,
  label: string,
 continent: string
}

const AddSubs = ( props:any ) => {
  /*********************************Constantes**************************************** */
  const tenant= useAppSelector(state =>state.TenantSlice.id)

  const{currentUser}= useAuth()
 
 
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false)

  ////
  const [Nombre,setNombre] = useState('');
  const [OwnerName,setOwnerName] = useState('');
  const [OwnerMail,setOwnerMail]= useState('')
  const [StartDate,setStartDate]= useState('')
  const [EndDate,setEndDate]= useState('')
  const[FeaturesDisp, setFeaturesDisp]=useState<x[]>([])
  const [selectedItems, setSelectedItems] = useState<number[]>([]);
  const [modalOpen, setModalOpen] = useState(true); // Estado para controlar si el modal está abierto






  
  /************************************llamadas a la API ********************************************** */

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  
 



  /************************************************************************* */
  useEffect(() => {
    //se llama al ep de permisos 
    const fetchData = async () => {
      try {
        if (currentUser?.ListPermiso?.includes('Tenant.list')){
        if(tenant===0){
          const permisos = await getFeaturesDisponibles();
          setFeaturesDisp(permisos.data)
        }
        else{
          const permisos = await getFeaturesDisponiblesGlobal();
          setFeaturesDisp(permisos.data)
        }
      }} catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
       };
  
      fetchData();
  }, [props.Tenant])
  

    //const navigate = useNavigate();

    const handleSubmit =async (e:any) => {
    e.preventDefault();

    try{
      const featurespost= []
      for (const y of selectedItems){
        featurespost.push({id:y})
      }

      if(props.id===null){
        const body ={
          tenantId:tenant,
          name:Nombre,
          ownerFullName:OwnerName,
          ownerEmail:OwnerMail,
          startDate:StartDate,
          endDate:EndDate,
          Features:featurespost
        
        }
        if(tenant===0){
        await axios.post(API_URL+'/v1/suscription/create', body)
        .then(res=>{
          if (res.data.error){
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: res.data.error,
              showConfirmButton: false,
              timer: 1500
            
            })
          }
          else{
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Your Subscription has created',
              showConfirmButton: false,
              timer: 1500
            
            })
            getSubscriptionsList().then(response=>{
              props.setRecords(response.data)
          })
          setModalOpen(false);

          }
        /*window.location.reload();*/

      });
      }
      else{
        await axios.post(API_URL+'/v1/suscription/create', body)
        .then(res=>{ 
          if (res.data.error){
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: res.data.error,
              showConfirmButton: false,
              timer: 1500
            
            })
          }
          else{
              Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Your Subscription has created',
              showConfirmButton: false,
              timer: 1500
            })
            getSubscriptionsList().then(response=>{
              props.setRecords(response.data)
          })
          setModalOpen(false);

          }
        /*window.location.reload();*/
      });
      }
      //navigate('/support/SeeRequest')
    }
  }
    catch(error:any){
      console.log(error)

    }

    
   }

  

  ///////////////////////////////////////////////

  
  const handleCheckboxChange = (event:any) => {
    const { value, checked } = event.target;
    
    if (checked) {
        setSelectedItems((prevSelectedItems:Array<number>) => [...prevSelectedItems, Number(value)]);
    } else {
        setSelectedItems((prevSelectedItems:Array<number>) =>
            prevSelectedItems.filter((item) => item !== Number(value))
        );
    }
};
    
  


   

  return (
    
    <>


      {modalOpen&&props.id === null &&
      <div>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-600px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ViewModalHeader setID={props.setID} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
            <form className='form w-100' id='kt_login_signin_form' onSubmit={handleSubmit} >
        {/* begin::Heading */}
        {/*<Card4
        icon='/media/svg/files/NubeTD.svg'
        title=' '
        description=''></Card4>*/}
        <div className='text-center mb-5'>
        <h1 className='text-marino fw-bolder mb-3 f-titulo fs-md'>Add Subscription</h1>
        </div>
        {/* begin::Heading */}

        {/* begin::Login options */}

        <div className='mb-2 bg-light-info p-8 rounded f-parrafo'>
            <div className='text-info'>
              Please fill in the necessary fields to carry out the deployment.
            </div>
        </div>
        
        {/* Campos solicitud */}
        <div style={{ textAlign: 'center' }}>
          <div style={{ margin: 'auto', display: 'inline-block' }}>
            <SelectTenant />
          </div>
        </div>

      <br />
                                <div>
                                   <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo required' htmlFor="name">Subscription Name</label>
                                   <input type="text" 
                                   required
                                   name='name' 
                                   className='form-control form-control-solid border-gray-300 f-parrafo' 
                                   id='Nombre'
                                   value={Nombre}
                                   onChange={(e:any) => setNombre(e.target.value)}
                                   />
                                </div>

                              <div className='row'>
                                <div className='col'>
                                   <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo required' htmlFor="name">Owner Full Name</label>
                                   <input type="text" 
                                   required
                                   className='form-control form-control-solid border-gray-300 f-parrafo' 
                                   value={OwnerName}
                                   onChange={(e:any) => setOwnerName(e.target.value)}
                                   />
                                </div>

                                <div className='col'>
                                   <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo required' htmlFor="name">Owner Email</label>
                                   <input type="email" 
                                   required
                                   className='form-control form-control-solid border-gray-300 f-parrafo' 
                                   value={OwnerMail}
                                   onChange={(e:any) => setOwnerMail(e.target.value)}
                                   />
                                </div>
                              </div>
                                <br />
                                <div className='row'>
                                  <div className='col'>
                                    <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo required' htmlFor="name">Subscription start date</label>
                                    <input type="date" 
                                    required
                                    className='form-control form-control-solid border-gray-300 f-parrafo' 
                                    value={StartDate}
                                    onChange={(e:any) => setStartDate(e.target.value)}
                                    />
                                  </div>
                                  <div className='col'>
                                    <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo required' htmlFor="name">Subscription start date</label>
                                    <input type="date" 
                                    required
                                    className='form-control form-control-solid border-gray-300 f-parrafo' 
                                    value={EndDate}
                                    onChange={(e:any) => setEndDate(e.target.value)}
                                    />
                                  </div>

                                </div>
                                <br /> 
                                <p className='form-label fw-bolder text-marino  text-center fs-3 mb-0 f-parrafo' >Features</p>
                                <br />
                                <div className="card-body card-scroll h-200px f-parrafo">
                                  {FeaturesDisp.map((feat:any)=>(
                                    <>
                                    
                                  <label className='form-check form-check-custom form-check-solid align-items-start'>
                                    <input
                                      className='form-check-input me-3'
                                      type='checkbox'
                                      name='email-preferences[]'   
                                      value={feat.id}     
                                      onChange={handleCheckboxChange} 
                                      defaultChecked={selectedItems.includes(Number(feat.id))} 
                                      
                                    />

                                    <span className='form-check-label d-flex flex-column align-items-start'>
                                      <span className='fw-bolder text-dark fs-5 mb-0'>{feat.name} </span>
                                      <span className='text-muted fs-6'>
                                        {feat.Permissions.map((p:any,i:any)=>(
                                        <p key={i}><strong>{p.name}</strong>: {p.description}</p>
                                        ))}
                                      </span>
                                    </span>
                                  </label>
                                  <div className='separator separator-dashed my-6'></div>
                                  </>))}

                                      
                                      </div>
                           
                               
                                      {/* end::Label */}
                                    {/* end::Radio */}

                                {/* begin::Action */}
                                <br />
                                <div className='d-grid mb-10 justify-content-center'>

                                  <div className='row'>
                                    <div className='col'>
                                      <button
                                          type='submit'
                                          id='kt_sign_in_submit'
                                          className='btn btn-primary'
                                  
                                          
                                        >
                                          {!loading && <span className='indicator-label'>Save</span>}
                                          {loading && (
                                            <span className='indicator-progress' style={{display: 'block'}}>
                                            Please wait...
                                              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                          )}
                                        </button>
                                    </div>
                                    <div className='col'>
                                        <button
                                        style={{width:'200px'}}
                                        className='btn text-pink border border-pink'
                                        onClick={() => props.setID(undefined)}

                                        >
                                          Cancel
                                        </button>
                                      </div>
                                  </div>
                                  
                                  
                                </div>
                                {/* end::Action */}

                            </form>
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
      </div>
      }   
      
    </>
  )
}
export {AddSubs}